import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  name: string;
  shortName: string;
  description: string;
  badge?: string;
  price: string;
  priceNum: number;
  oldPrice: string;
  savings?: string;
  url: string;
  featured?: boolean;
}
const options: PricingOption[] = [{
  id: 'tomos',
  emoji: '🌍',
  name: 'SOCIALES PRIMARIA LISTA',
  shortName: '6 Tomos',
  description: '6 tomos + 300 actividades + bonos',
  price: '$19.990',
  priceNum: 19990,
  oldPrice: '$49.990',
  url: 'https://www.profepack.com/cart/48097217970432:1'
}, {
  id: 'completo',
  emoji: '🏆',
  name: 'PACK SOCIALES + SISTEMA GESTION DOCENTE 360',
  shortName: 'Pack Completo',
  description: '6 tomos + Sistema de Gestión 360 + bonos',
  badge: 'AHORRÁS $10.000',
  price: '$29.990',
  priceNum: 29990,
  oldPrice: '$59.990',
  savings: '50% OFF',
  url: 'https://www.profepack.com/cart/48113651515648:1',
  featured: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" aria-label="Precios y ofertas" className="bg-brand-card py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-197">
      <div className="max-w-xl mx-auto" data-id="element-198">
        <div className="text-center mb-10" data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3" data-id="element-200">
            Elegí tu <span className="text-brand-accent" data-id="element-201">PROFEPACK:</span>
          </h2>
          <p className="text-white/60 text-sm md:text-base" data-id="element-202">
            Todas las opciones incluyen los 6 bonos estratégicos
          </p>
        </div>
        <div className="flex flex-col gap-4" data-id="element-203">
          {options.map(option => {
          const isSelected = selected === option.id;
          return <button key={option.id} onClick={() => setSelected(option.id)} aria-pressed={isSelected} className={`${`w-full text-left rounded-2xl p-5 md:p-6 border-2 ${isSelected ? 'border-brand-accent bg-brand-accent/5' : 'border-brand-border bg-brand-dark hover:border-white/20'} ${option.featured && !isSelected ? 'border-brand-accent/30' : ''} ${option.featured ? 'order-first md:order-none' : ''}`} pt-[10px] pb-[10px] pr-[20px]`} data-id="element-204">
                <div className="flex items-center gap-4" data-id="element-205">
                  <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-accent bg-brand-accent' : 'border-white/30 bg-transparent'}`} data-id="element-206">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-brand-dark" data-id="element-207" />}
                  </div>
                  <div className="flex-grow min-w-0" data-id="element-208">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-209">
                      <span className="text-lg" aria-hidden="true" data-id="element-210">
                        {option.emoji}
                      </span>
                      <span className={`font-black text-base md:text-lg ${isSelected ? 'text-white' : 'text-white/80'}`} data-id="element-211">
                        {option.name}
                      </span>
                      {option.featured && <span className="bg-brand-accent text-brand-dark text-[10px] md:text-xs font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider" data-id="element-212">
                          ⭐ Más elegido
                        </span>}
                      {option.badge && isSelected && <span className="bg-brand-accent/20 text-brand-accent text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-213">
                          {option.badge}
                        </span>}
                    </div>
                    <p className={`text-sm md:text-base mt-1 ${isSelected ? 'text-white/70' : 'text-white/50'}`} data-id="element-214">
                      {option.description}
                    </p>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-215">
                    <div className={`text-sm line-through ${isSelected ? 'text-white/50' : 'text-white/50'}`} data-id="element-216">
                      {option.oldPrice}
                    </div>
                    <div className={`text-2xl md:text-3xl font-black ${isSelected ? 'text-brand-accent' : 'text-white/70'}`} data-id="element-217">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
          <button onClick={() => window.open(selectedOption.url, '_blank')} aria-label={`Comprar ${selectedOption.name} por ${selectedOption.price} ARS`} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-lg md:text-xl py-5 md:py-6 rounded-2xl transition-colors flex items-center justify-center gap-2 mt-2 active:scale-[0.98]" data-id="element-218">
            SÍ, QUIERO {selectedOption.shortName.toUpperCase()} →
          </button>
        </div>
        <p className="text-sm text-center text-white/60 italic mt-4 mb-8" data-id="element-219">
          {selected === 'completo' ? 'La opción más elegida por docentes de primaria' : 'Podés sumar el Sistema de Gestión cuando quieras'}
        </p>
        <div className="bg-brand-dark rounded-2xl p-6 border border-brand-border mb-8" data-id="element-220">
          <p className="text-xs font-bold text-white/60 uppercase tracking-widest mb-4" data-id="element-221">
            {selectedOption.name} incluye:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3" data-id="element-222">
            {(selected === 'completo' ? ['6 Tomos de actividades (1.º a 6.º)', '+300 actividades con solucionario', 'Solucionario docente completo', 'Sistema de Gestión Docente 360', 'Planificaciones Anuales editables', '18 Evaluaciones con Modelo A y B', 'Rúbricas y planillas de seguimiento', 'Proyectos ESI y Ambiental listos', '6 Bonos estratégicos', 'Acceso inmediato en PDF'] : ['6 Tomos completos', '+300 actividades con solucionario', 'Solucionario docente', 'Actividades fotocopiables', '6 Bonos estratégicos', 'Acceso inmediato PDF']).map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-223">
                <span className="text-brand-accent text-sm mt-0.5" aria-hidden="true" data-id="element-224">
                  ✓
                </span>
                <span className="text-white/80 text-sm md:text-base font-medium" data-id="element-225">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-white/60 font-medium text-sm" data-id="element-226">
          <span data-id="element-227">🔒 Pago seguro</span>
          <span data-id="element-228">⚡ Acceso en 5 min</span>
          <span data-id="element-229">🛡️ Garantía 7 días</span>
          <span data-id="element-230">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}